'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _quicksend = require('redux/modules/quicksend');

var quickSendActions = _interopRequireWildcard(_quicksend);

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _components = require('components');

var _forms = require('helpers/forms');

var _reactRouterRedux = require('react-router-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _project = require('redux/modules/project');

var _quickSendFormValidation = require('./quickSendFormValidation');

var _quickSendFormValidation2 = _interopRequireDefault(_quickSendFormValidation);

var _projects = require('selectors/projects');

var _projects2 = require('helpers/projects');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _SubjectRow = require('./form/SubjectRow');

var _SubjectRow2 = _interopRequireDefault(_SubjectRow);

var _MessageRow = require('./form/MessageRow');

var _MessageRow2 = _interopRequireDefault(_MessageRow);

var _ExpireDateRow = require('./form/ExpireDateRow');

var _ExpireDateRow2 = _interopRequireDefault(_ExpireDateRow);

var _EmailField = require('./form/EmailField');

var _EmailField2 = _interopRequireDefault(_EmailField);

var _WatermarkField = require('./form/WatermarkField');

var _WatermarkField2 = _interopRequireDefault(_WatermarkField);

var _DownloadField = require('./form/DownloadField');

var _DownloadField2 = _interopRequireDefault(_DownloadField);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _QuickSendFormButtons = require('./form/QuickSendFormButtons');

var _QuickSendFormButtons2 = _interopRequireDefault(_QuickSendFormButtons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendForm.scss');

var formDefaults = {
  subject: '',
  message: '',
  expiryDate: '',
  directAccessWatermark: false,
  fwd: false,
  download: false
};

var QuickSendForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    mediaFailedListData: state.project.mediaFailedListData,
    mediaList: state.project.mediaListData,
    recipientsList: (0, _projects.getRecipients)(state),
    submittedCloudFiles: state.project.submittedCloudFiles,
    submittedMediaFiles: state.project.submittedMediaFiles
  };
}, (0, _extends3.default)({}, quickSendActions, { publish: _project.publish, pushState: _reactRouterRedux.push })), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'quickSendForm',
  propNamespace: 'quickSendForm',
  initialValues: formDefaults,
  validate: _quickSendFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendForm, _Component);

  function QuickSendForm() {
    var _ref;

    (0, _classCallCheck3.default)(this, QuickSendForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = QuickSendForm.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForm)).call.apply(_ref, [this].concat(args)));

    _this.state = { step: 1 };
    return _this;
  }

  (0, _createClass3.default)(QuickSendForm, [{
    key: 'cancel',
    value: function cancel() {
      this.props.pushState('/quick-send/sent');
    }
  }, {
    key: 'publish',
    value: function publish() {
      var projectId = this.props.projectId;

      return this.props.publish(projectId).promise;
    }
  }, {
    key: 'goStep',
    value: function goStep(step) {
      this.setState({ step: step });
    }
  }, {
    key: 'goNextStep',
    value: function goNextStep() {
      this.goStep(this.state.step + 1);
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      var _this2 = this;

      var _props = this.props,
          projectId = _props.projectId,
          t = _props.t,
          qsSave = _props.qsSave,
          setOutdated = _props.setOutdated;

      var data = (0, _forms.normalizeFormData)(formData);
      data.projectId = projectId;
      return qsSave(data).promise.then(this.publish).then(function () {
        setOutdated();
        _toastr2.default.success(t('Successfully sent!'));
        return _this2.cancel();
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'isUploadsCompleted',
    value: function isUploadsCompleted() {
      var _props2 = this.props,
          mediaList = _props2.mediaList,
          submittedCloudFiles = _props2.submittedCloudFiles,
          submittedMediaFiles = _props2.submittedMediaFiles,
          mediaFailedListData = _props2.mediaFailedListData;

      var submittedFilesCount = submittedMediaFiles.length + submittedCloudFiles.length;
      var failedFilesCount = mediaFailedListData.length;
      var uploadedFilesCount = mediaList.length;
      return uploadedFilesCount && uploadedFilesCount === submittedFilesCount - failedFilesCount;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          t = _props3.t,
          projectId = _props3.projectId,
          recipientsList = _props3.recipientsList,
          _props3$quickSendForm = _props3.quickSendForm,
          handleSubmit = _props3$quickSendForm.handleSubmit,
          submitting = _props3$quickSendForm.submitting,
          invalid = _props3$quickSendForm.invalid;
      var step = this.state.step;

      var isSubmitDisabled = submitting || invalid || (0, _isEmpty4.default)(recipientsList) || !this.isUploadsCompleted();

      return _react2.default.createElement(
        'div',
        { className: 'pos-rel' },
        _react2.default.createElement(
          _Button2.default,
          {
            className: (0, _classnames2.default)('btn-clear', styles.backButton, (0, _defineProperty3.default)({}, styles.visible, step > 1)),
            onClick: function onClick() {
              return _this3.goStep(1);
            }
          },
          _react2.default.createElement('i', { className: 'icon-chevron-thin-left' })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('row wide-border', styles.slider, styles['step' + step]) },
          _react2.default.createElement(
            'div',
            { className: styles.mainSection },
            _react2.default.createElement(
              'div',
              { className: 'row wide-border' },
              _react2.default.createElement(
                'div',
                { className: styles.mainForm },
                _react2.default.createElement(_EmailField2.default, { projectId: projectId }),
                _react2.default.createElement(
                  'form',
                  { onSubmit: handleSubmit(this.submit) },
                  _react2.default.createElement(_SubjectRow2.default, null),
                  _react2.default.createElement(_MessageRow2.default, null)
                )
              ),
              _react2.default.createElement(_components.QuickSendUploadArea, { projectId: projectId, className: styles.uploadForm })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.optionsSection },
            _react2.default.createElement(
              'div',
              { className: 'row wide-border' },
              _react2.default.createElement(
                'div',
                { className: styles.filesManagement },
                _react2.default.createElement(
                  'h4',
                  { className: 'hint' },
                  t('Files Management')
                ),
                _react2.default.createElement(_components.MediaList, {
                  projectId: projectId,
                  projectType: _projects2.projectTypes.quickSend,
                  multipleBoxsets: false,
                  hideOwner: true,
                  hideIsrc: true,
                  hidePackId: true,
                  hideReplaceFile: true,
                  hideDelete: true
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.optionsForm },
                _react2.default.createElement(
                  'h4',
                  { className: 'hint' },
                  t('Options')
                ),
                _react2.default.createElement(_ExpireDateRow2.default, null),
                _react2.default.createElement(
                  'div',
                  { className: 'margin-top-20' },
                  _react2.default.createElement(_WatermarkField2.default, { className: 'margin-right-20' }),
                  _react2.default.createElement(_DownloadField2.default, null)
                )
              )
            )
          )
        ),
        _react2.default.createElement(_QuickSendFormButtons2.default, {
          submitting: submitting,
          isSubmitDisabled: isSubmitDisabled,
          onNext: this.goNextStep,
          onSubmit: handleSubmit(this.submit),
          step: step
        })
      );
    }
  }]);
  return QuickSendForm;
}(_react.Component), _class3.propTypes = {
  mediaFailedListData: _propTypes2.default.array,
  mediaList: _propTypes2.default.array,
  projectId: _propTypes2.default.number,
  publish: _propTypes2.default.func,
  pushState: _propTypes2.default.func,
  qsSave: _propTypes2.default.func,
  quickSendForm: _propTypes2.default.object,
  recipientsList: _propTypes2.default.array,
  setOutdated: _propTypes2.default.func,
  submittedCloudFiles: _propTypes2.default.array,
  submittedMediaFiles: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goNextStep', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'goNextStep'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = QuickSendForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForm.js
// module id = 2072
// module chunks = 1